import * as i0 from '@angular/core';
import { Pipe, Component, ContentChildren, forwardRef, Input, NgModule, EventEmitter, Inject, Output, Directive, HostListener, ViewEncapsulation, ViewChild, ViewChildren } from '@angular/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';
import * as i3 from '@angular/material/progress-bar';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatIconModule } from '@angular/material/icon';
import * as i4 from '@angular/material/card';
import { MatCardModule } from '@angular/material/card';
import * as i2$1 from '@eui/components/legacy/ux-button';
import { UxButtonComponentModule } from '@eui/components/legacy/ux-button';
import * as i1 from '@angular/common/http';
import { HttpHeaders, HttpParams, HttpEventType } from '@angular/common/http';
import * as i2$2 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import { merge } from 'rxjs';
import { startWith } from 'rxjs/operators';
import * as i5 from '@eui/components/legacy/common/ux-directives';
import { UxTooltipModule } from '@eui/components/legacy/common/ux-directives';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import * as i1$1 from '@eui/core';

class UxFileUpload {
    constructor(values = {}) {
        Object.assign(this, values);
    }
}

class BytesPipe {
    transform(bytes) {
        if (isNaN(parseFloat('' + bytes)) || !isFinite(bytes)) {
            return '-';
        }
        if (bytes <= 0) {
            return '0';
        }
        let units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB'], number = Math.floor(Math.log(bytes) / Math.log(1024));
        return (bytes / Math.pow(1024, Math.floor(number))).toFixed(1) + ' ' + units[number];
    }
}
/** @nocollapse */ BytesPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: BytesPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
/** @nocollapse */ BytesPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: BytesPipe, name: "bytes" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: BytesPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'bytes' }]
        }] });

class UxMFileUploadQueueComponent {
    constructor() {
        this.files = [];
        this.httpRequestHeaders = new HttpHeaders();
        this.httpRequestParams = new HttpParams();
        this.fileAlias = 'file';
    }
    /** Combined stream of all of the file upload remove change events. */
    get fileUploadRemoveEvents() {
        return merge(...this.fileUploads.map(fileUpload => fileUpload.removeEvent));
    }
    ngAfterViewInit() {
        // When the list changes, re-subscribe
        this._changeSubscription = this.fileUploads.changes.pipe(startWith(null)).subscribe(() => {
            if (this._fileRemoveSubscription) {
                this._fileRemoveSubscription.unsubscribe();
            }
            this._listenToFileRemoved();
        });
    }
    add(file) {
        this.files.push(file);
    }
    uploadAll() {
        this.fileUploads.forEach((fileUpload) => { fileUpload.upload(); });
    }
    removeAll() {
        this.files.splice(0, this.files.length);
    }
    ngOnDestroy() {
        if (this.files) {
            this.removeAll();
        }
    }
    _listenToFileRemoved() {
        this._fileRemoveSubscription = this.fileUploadRemoveEvents.subscribe((event) => {
            this.files.splice(event.id, 1);
        });
    }
}
/** @nocollapse */ UxMFileUploadQueueComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxMFileUploadQueueComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ UxMFileUploadQueueComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.3", type: UxMFileUploadQueueComponent, selector: "ux-m-file-upload-queue", inputs: { httpUrl: "httpUrl", httpRequestHeaders: "httpRequestHeaders", httpRequestParams: "httpRequestParams", fileAlias: "fileAlias" }, queries: [{ propertyName: "fileUploads", predicate: i0.forwardRef(function () { return UxMFileUploadComponent; }) }], exportAs: ["uxMFileUploadQueue"], ngImport: i0, template: "<ng-content></ng-content>\n<br>\n<ux-button *ngIf=\"httpUrl && files.length > 0\" (click)=\"uploadAll()\">{{'eui.fileUpload.uploadAll'|translate}}</ux-button>\n", dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$1.UxButtonComponent, selector: "ux-button", inputs: ["type", "styleClass", "typeClass", "iconClass", "isOutline", "isSecondary", "isSmall", "isLarge", "isBlock", "isFlat", "isLineWrap", "tabindex", "ariaLabel", "isDisabled", "e2eAttr"] }, { kind: "pipe", type: i2$2.TranslatePipe, name: "translate" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxMFileUploadQueueComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ux-m-file-upload-queue', exportAs: 'uxMFileUploadQueue', template: "<ng-content></ng-content>\n<br>\n<ux-button *ngIf=\"httpUrl && files.length > 0\" (click)=\"uploadAll()\">{{'eui.fileUpload.uploadAll'|translate}}</ux-button>\n" }]
        }], propDecorators: { fileUploads: [{
                type: ContentChildren,
                args: [forwardRef(() => UxMFileUploadComponent)]
            }], httpUrl: [{
                type: Input
            }], httpRequestHeaders: [{
                type: Input
            }], httpRequestParams: [{
                type: Input
            }], fileAlias: [{
                type: Input
            }] } });
class UxMFileUploadQueueModule {
}
/** @nocollapse */ UxMFileUploadQueueModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxMFileUploadQueueModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ UxMFileUploadQueueModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: UxMFileUploadQueueModule, declarations: [UxMFileUploadQueueComponent], imports: [CommonModule,
        UxButtonComponentModule,
        TranslateModule], exports: [UxMFileUploadQueueComponent] });
/** @nocollapse */ UxMFileUploadQueueModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxMFileUploadQueueModule, imports: [CommonModule,
        UxButtonComponentModule,
        TranslateModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxMFileUploadQueueModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        UxButtonComponentModule,
                        TranslateModule
                    ],
                    exports: [UxMFileUploadQueueComponent],
                    declarations: [UxMFileUploadQueueComponent],
                    providers: []
                }]
        }] });

class UxMFileUploadComponent {
    constructor(http, uxMFileUploadQueue) {
        this.http = http;
        this.uxMFileUploadQueue = uxMFileUploadQueue;
        this.isUploading = false;
        this.progressPercentage = 0;
        this.loaded = 0;
        this.total = 0;
        this.httpUrl = '';
        this.httpRequestHeaders = new HttpHeaders();
        this.httpRequestParams = new HttpParams();
        this.fileAlias = 'file';
        this.removeEvent = new EventEmitter();
        this.onUpload = new EventEmitter();
        this.onUploadStart = new EventEmitter();
        if (uxMFileUploadQueue) {
            this.httpUrl = uxMFileUploadQueue.httpUrl || this.httpUrl;
            this.httpRequestHeaders = uxMFileUploadQueue.httpRequestHeaders || this.httpRequestHeaders;
            this.httpRequestParams = uxMFileUploadQueue.httpRequestParams || this.httpRequestParams;
            this.fileAlias = uxMFileUploadQueue.fileAlias || this.fileAlias;
        }
        else {
            this.httpUrl = null;
        }
    }
    get file() {
        return this._file;
    }
    set file(file) {
        this._file = file;
        this.total = this._file.size;
    }
    upload() {
        this.isUploading = true;
        // How to set the alias?
        let formData = new FormData();
        formData.append(this.fileAlias, this._file, this._file.name);
        this.onUploadStart.emit(true);
        this.fileUploadSubscription = this.http.post(this.httpUrl, formData, {
            headers: this.httpRequestHeaders,
            observe: 'events',
            params: this.httpRequestParams,
            reportProgress: true,
            responseType: 'json'
        }).subscribe((event) => {
            if (event.type === HttpEventType.UploadProgress) {
                this.progressPercentage = Math.floor(event.loaded * 100 / event.total);
                this.loaded = event.loaded;
                this.total = event.total;
            }
            this.onUpload.emit({ file: this._file, event: event });
        }, (error) => {
            this.isUploading = false;
            this.onUpload.emit({ file: this._file, event: error });
        });
    }
    remove() {
        if (this.fileUploadSubscription) {
            this.fileUploadSubscription.unsubscribe();
        }
        this.removeEvent.emit(this);
    }
    ngOnDestroy() {
        if (this.fileUploadSubscription) {
            this.fileUploadSubscription.unsubscribe();
        }
    }
}
/** @nocollapse */ UxMFileUploadComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxMFileUploadComponent, deps: [{ token: i1.HttpClient }, { token: forwardRef(() => UxMFileUploadQueueComponent) }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ UxMFileUploadComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.3", type: UxMFileUploadComponent, selector: "ux-m-file-upload", inputs: { id: "id", httpUrl: "httpUrl", httpRequestHeaders: "httpRequestHeaders", httpRequestParams: "httpRequestParams", fileAlias: "fileAlias", file: "file" }, outputs: { removeEvent: "removeEvent", onUpload: "onUpload", onUploadStart: "onUploadStart" }, exportAs: ["uxMFileUpload"], ngImport: i0, template: "<mat-card>\n    <span class=\"file-info\">{{file.name}}({{file.size | bytes}})</span>\n    <section class=\"example-section\">\n        <mat-progress-bar class=\"example-margin\" [value]=\"progressPercentage\"></mat-progress-bar>\n        <div *ngIf=\"uxMFileUploadQueue.httpUrl\"\n             [ngClass]=\"{'disabled' : isUploading}\"\n            [uxTooltip]=\"'eui.fileUpload.uploadFile'|translate\"\n            color=\"none\"\n            position=\"top\"\n            size=\"auto\"\n            zIndex=\"auto\"\n            [always]=\"false\"\n            [rounded]=\"false\">\n            <span class=\"ux-icon ux-icon-fw ux-icon-2x ux-icon-level-up upload-file\" (click)=\"upload()\"></span>\n        </div>\n        <div [uxTooltip]=\"'eui.fileUpload.removeFile'|translate\"\n             color=\"none\"\n             position=\"top\"\n             size=\"auto\"\n             zIndex=\"auto\"\n             [always]=\"false\"\n             [rounded]=\"false\">\n            <span class=\"ux-icon ux-icon-fw ux-icon-2x ux-icon-times\" (click)=\"remove()\">\n            </span>\n        </div>\n    </section>\n    <span class=\"file-info\">{{progressPercentage}}%</span><span> {{loaded | bytes}} of {{total | bytes}}</span>\n</mat-card>\n", styles: [".example-section{align-content:center;align-items:center;display:flex;height:10px}.file-info{font-size:.85rem}.action{cursor:pointer;outline:none}a.disabled{pointer-events:none}.upload-file{color:var(eui-base-color-primary-100)}\n"], dependencies: [{ kind: "directive", type: i0.forwardRef(function () { return i2.NgClass; }), selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i0.forwardRef(function () { return i2.NgIf; }), selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i0.forwardRef(function () { return i3.MatProgressBar; }), selector: "mat-progress-bar", inputs: ["color", "value", "bufferValue", "mode"], outputs: ["animationEnd"], exportAs: ["matProgressBar"] }, { kind: "component", type: i0.forwardRef(function () { return i4.MatCard; }), selector: "mat-card", inputs: ["appearance"], exportAs: ["matCard"] }, { kind: "directive", type: i0.forwardRef(function () { return i5.UxTooltipDirective; }), selector: "[uxTooltip]", inputs: ["color", "uxTooltip", "position", "size", "rounded", "always", "zIndex"] }, { kind: "pipe", type: i0.forwardRef(function () { return i2$2.TranslatePipe; }), name: "translate" }, { kind: "pipe", type: i0.forwardRef(function () { return BytesPipe; }), name: "bytes" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxMFileUploadComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ux-m-file-upload', exportAs: 'uxMFileUpload', host: {
                        'class': '',
                    }, template: "<mat-card>\n    <span class=\"file-info\">{{file.name}}({{file.size | bytes}})</span>\n    <section class=\"example-section\">\n        <mat-progress-bar class=\"example-margin\" [value]=\"progressPercentage\"></mat-progress-bar>\n        <div *ngIf=\"uxMFileUploadQueue.httpUrl\"\n             [ngClass]=\"{'disabled' : isUploading}\"\n            [uxTooltip]=\"'eui.fileUpload.uploadFile'|translate\"\n            color=\"none\"\n            position=\"top\"\n            size=\"auto\"\n            zIndex=\"auto\"\n            [always]=\"false\"\n            [rounded]=\"false\">\n            <span class=\"ux-icon ux-icon-fw ux-icon-2x ux-icon-level-up upload-file\" (click)=\"upload()\"></span>\n        </div>\n        <div [uxTooltip]=\"'eui.fileUpload.removeFile'|translate\"\n             color=\"none\"\n             position=\"top\"\n             size=\"auto\"\n             zIndex=\"auto\"\n             [always]=\"false\"\n             [rounded]=\"false\">\n            <span class=\"ux-icon ux-icon-fw ux-icon-2x ux-icon-times\" (click)=\"remove()\">\n            </span>\n        </div>\n    </section>\n    <span class=\"file-info\">{{progressPercentage}}%</span><span> {{loaded | bytes}} of {{total | bytes}}</span>\n</mat-card>\n", styles: [".example-section{align-content:center;align-items:center;display:flex;height:10px}.file-info{font-size:.85rem}.action{cursor:pointer;outline:none}a.disabled{pointer-events:none}.upload-file{color:var(eui-base-color-primary-100)}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: UxMFileUploadQueueComponent, decorators: [{
                    type: Inject,
                    args: [forwardRef(() => UxMFileUploadQueueComponent)]
                }] }]; }, propDecorators: { id: [{
                type: Input
            }], httpUrl: [{
                type: Input
            }], httpRequestHeaders: [{
                type: Input
            }], httpRequestParams: [{
                type: Input
            }], fileAlias: [{
                type: Input
            }], removeEvent: [{
                type: Output
            }], onUpload: [{
                type: Output
            }], onUploadStart: [{
                type: Output
            }], file: [{
                type: Input
            }] } });
class UxMFileUploadComponentModule {
}
/** @nocollapse */ UxMFileUploadComponentModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxMFileUploadComponentModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ UxMFileUploadComponentModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: UxMFileUploadComponentModule, declarations: [UxMFileUploadComponent, BytesPipe], imports: [CommonModule,
        MatProgressBarModule,
        MatIconModule,
        MatCardModule,
        UxTooltipModule,
        TranslateModule], exports: [UxMFileUploadComponent, BytesPipe] });
/** @nocollapse */ UxMFileUploadComponentModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxMFileUploadComponentModule, imports: [CommonModule,
        MatProgressBarModule,
        MatIconModule,
        MatCardModule,
        UxTooltipModule,
        TranslateModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxMFileUploadComponentModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        MatProgressBarModule,
                        MatIconModule,
                        MatCardModule,
                        UxTooltipModule,
                        TranslateModule
                    ],
                    exports: [UxMFileUploadComponent, BytesPipe],
                    declarations: [UxMFileUploadComponent, BytesPipe]
                }]
        }] });

class FileUploadInputForDirective {
    constructor(element) {
        this.element = element;
        this.onFileSelected = new EventEmitter();
        this._element = this.element.nativeElement;
    }
    change(event) {
        let files = Array.from(event.target.files);
        this.onFileSelected.emit(files);
        // TODO: check if we can remove this. Is this intentional?
        this.element.nativeElement.value = '';
    }
    onDrop(event) {
        let files = event.dataTransfer.files;
        event.preventDefault();
        event.stopPropagation();
        this.onFileSelected.emit(Array.from(files));
        // TODO: check if we can remove this. Is this intentional?
        this.element.nativeElement.value = '';
    }
    onDropOver(event) {
        event.preventDefault();
    }
}
/** @nocollapse */ FileUploadInputForDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: FileUploadInputForDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ FileUploadInputForDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.0.3", type: FileUploadInputForDirective, selector: "input[fileUploadInputFor], div[fileUploadInputFor]", outputs: { onFileSelected: "onFileSelected" }, host: { listeners: { "change": "change($event)", "drop": "onDrop($event)", "dragover": "onDropOver($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: FileUploadInputForDirective, decorators: [{
            type: Directive,
            args: [{
                    // eslint-disable-next-line @angular-eslint/directive-selector
                    selector: 'input[fileUploadInputFor], div[fileUploadInputFor]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { onFileSelected: [{
                type: Output
            }], change: [{
                type: HostListener,
                args: ['change', ['$event']]
            }], onDrop: [{
                type: HostListener,
                args: ['drop', ['$event']]
            }], onDropOver: [{
                type: HostListener,
                args: ['dragover', ['$event']]
            }] } });
class UxFileUploadInputForModule {
}
/** @nocollapse */ UxFileUploadInputForModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxFileUploadInputForModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ UxFileUploadInputForModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: UxFileUploadInputForModule, declarations: [FileUploadInputForDirective], imports: [CommonModule], exports: [FileUploadInputForDirective] });
/** @nocollapse */ UxFileUploadInputForModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxFileUploadInputForModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxFileUploadInputForModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [FileUploadInputForDirective],
                    declarations: [FileUploadInputForDirective],
                }]
        }] });

class UxFileUploadComponent {
    constructor(uxAppShellService, translate) {
        this.uxAppShellService = uxAppShellService;
        this.translate = translate;
        this.inputType = 'default';
        this.dragAndDropLabel = 'eui.fileUpload.dragAndDrop';
        this.bytesOfLabel = 'eui.fileUpload.bytesOf';
        this.bytesLabel = 'eui.fileUpload.bytes';
        this.maxFileSize = 100000000;
        this._isMultiple = true;
        this.invalidFileSize = new EventEmitter();
        this.onUploadEmitter = new EventEmitter();
        this.onUploadStartEmitter = new EventEmitter();
        this.onRemoveFile = new EventEmitter();
        this.predefinedFiles = [];
        this.uploadedFiles = [];
        this.invalidSize = false;
        this.fromEntries = arr => Object.assign({}, ...Array.from(arr, ([k, v]) => ({ [k]: v })));
        this.propagateChange = (_) => {
        };
        this.propagateTouched = (_) => {
        };
    }
    get isMultiple() { return this._isMultiple; }
    set isMultiple(value) { this._isMultiple = coerceBooleanProperty(value); }
    ngAfterViewInit() {
        setTimeout(() => {
            if (this.predefinedFiles && this.predefinedFiles.length > 0) {
                this.predefinedFiles.forEach(f => this.fileUploadQueue.add(f));
            }
        }, 0);
    }
    setDisabledState(isDisabled) {
        throw new Error('Method not implemented.');
    }
    ngOnInit() {
        if (!this.chooseFileLabel) {
            this.chooseFileLabel = this.isMultiple ? 'eui.fileUpload.chooseFiles' : 'eui.fileUpload.chooseFile';
        }
    }
    validate(control) {
        const errors = new Map([]);
        // validate file size
        if (control.value?.length > 0 && Array.isArray(control.value)) {
            control.value.forEach((chosenFile, index) => {
                if (chosenFile.size > this.maxFileSize) {
                    errors.set(`file_${index}_size_exceed`, true);
                    this.invalidFileSize.emit(true);
                }
            });
        }
        // validate number of files
        if (control.value?.length > this.numberOfFiles && Array.isArray(control.value)) {
            errors.set('numberOfFilesExceed', true);
        }
        return this.fromEntries(errors);
    }
    ngOnChanges(changes) {
        if (changes['isMultiple']?.currentValue) {
            this.setChooseFileLabel();
        }
        if (changes['numberOfFiles']?.currentValue) {
            this.isMultiple = true;
        }
        if (changes['chooseFileLabel']) {
            this.setChooseFileLabel();
        }
    }
    onChange(files) {
        if (this.fileUploadQueue) {
            files.forEach((file) => this.fileUploadQueue.add(file));
            this.fileSizeCheck();
            if (this.isMultiple) {
                this.isFileNumberOk(this.fileUploadQueue.files);
            }
        }
        this.propagateChange(this.fileUploadQueue.files);
    }
    onUpload(e) {
        if (e.event.status === 200 && (!e.event.type || e.event.type === 4)) {
            const file = e.file;
            const found = this.uploadedFiles.filter((uploadedFile) => {
                return uploadedFile.name === file.name &&
                    uploadedFile.size === file.size &&
                    uploadedFile.lastModified === new Date(file.lastModified);
            });
            if (found.length === 0) {
                this.uploadedFiles.push({
                    name: file.name,
                    size: file.size,
                    lastModified: new Date(file.lastModified),
                });
            }
            this.onUploadEmitter.emit(e.event);
        }
    }
    onUploadStart(event) {
        this.onUploadStartEmitter.emit(event);
    }
    removeEvent(e) {
        const file = e.file;
        this.uploadedFiles.slice(this.uploadedFiles.findIndex((uploadedFile) => {
            return uploadedFile.name !== file.name ||
                (uploadedFile.name === file.name && uploadedFile.size !== file.size) ||
                (uploadedFile.name === file.name && uploadedFile.size === file.size
                    && uploadedFile.lastModified.getTime() !== new Date(file.lastModified).getTime());
        }), 1);
        this.predefinedFiles.splice(this.predefinedFiles.findIndex((f) => file === f), 0);
        this.fileUploadQueue.files.splice(this.fileUploadQueue.files.findIndex((f) => file === f), 0);
        this.propagateChange(this.fileUploadQueue.files);
        this.onRemoveFile.emit(true);
    }
    clearAll() {
        this.fileUploadQueue.removeAll();
    }
    clearUploadedFiles() {
        if (this.uploadedFiles && this.uploadedFiles.length > 0) {
            this.uploadedFiles.forEach((uploadedFile) => {
                this.fileUploadQueue.files = this.fileUploadQueue.files.filter((file) => {
                    return uploadedFile.name !== file.name ||
                        (uploadedFile.name === file.name && uploadedFile.size !== file.size) ||
                        (uploadedFile.name === file.name && uploadedFile.size === file.size &&
                            uploadedFile.lastModified.getTime() !== new Date(file.lastModified).getTime());
                });
            });
        }
        this.uploadedFiles = [];
        this.propagateChange(this.uploadedFiles);
    }
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    registerOnTouched(fn) {
    }
    writeValue(value) {
        if (value) {
            this.uploadedFiles = value.map(v => this.typeFileToUxFileUpload(v));
            this.predefinedFiles = [...value];
            this.loadedIcons();
        }
    }
    typeFileToUxFileUpload(file) {
        return {
            name: file.name,
            size: file.size,
            lastModified: new Date(file.lastModified * 1000)
        };
    }
    fileSizeCheck() {
        let invalidelements = [];
        this.fileUploadQueue.files.forEach((chosenFile, index) => {
            if (chosenFile.size > this.maxFileSize) {
                invalidelements.push(chosenFile);
            }
        });
        // remove invalid elements
        invalidelements.forEach((file) => {
            let index = this.fileUploadQueue.files.findIndex(item => item.name === file.name);
            this.fileUploadQueue.files.splice(index, 1);
        });
        this.invalidFileSize.emit(invalidelements.length !== 0);
        this.fileUploadQueue.files = this.fileUploadQueue.files.filter((chosenFile) => {
            return chosenFile.size <= this.maxFileSize;
        });
        // Object.assign(this.fileUploadQueue, { files });
    }
    loadedIcons() {
        // TODO: code-smell
        setTimeout(() => {
            this.fileUploads.map((fileUpload) => {
                const loaded = fileUpload.total;
                return Object.assign({}, fileUpload, { progressPercentage: 100, loaded });
            });
        });
    }
    isFileNumberOk(files) {
        if (files.length > this.numberOfFiles) {
            const restrictedFiles = files.slice(0, this.numberOfFiles);
            files.splice(0, files.length, ...restrictedFiles);
            this.uxAppShellService.growl(this.translate ? {
                severity: 'danger',
                summary: this.translate.instant('eui.fileUpload.maxNumberOfFilesExceed.summary'),
                detail: this.translate.instant('eui.fileUpload.maxNumberOfFilesExceed.details', { numberOfFiles: this.numberOfFiles })
            } : {
                severity: 'danger',
                summary: 'Maximum number of selected files exceeded',
                detail: `Please select ${this.numberOfFiles} files`
            });
            return false;
        }
        return true;
    }
    setChooseFileLabel() {
        // in case File label has not been provided (is null or undefined), then set a default
        if (!this.chooseFileLabel) {
            this.chooseFileLabel = this.isMultiple ? 'eui.fileUpload.chooseFiles' : 'eui.fileUpload.chooseFile';
        }
    }
}
/** @nocollapse */ UxFileUploadComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxFileUploadComponent, deps: [{ token: i1$1.UxAppShellService }, { token: i2$2.TranslateService }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ UxFileUploadComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.3", type: UxFileUploadComponent, selector: "ux-file-upload", inputs: { inputType: "inputType", endpoint: "endpoint", dragAndDropLabel: "dragAndDropLabel", bytesOfLabel: "bytesOfLabel", bytesLabel: "bytesLabel", chooseFileLabel: "chooseFileLabel", allowedFiles: "allowedFiles", maxFileSize: "maxFileSize", isMultiple: "isMultiple", iconClass: "iconClass", numberOfFiles: "numberOfFiles" }, outputs: { invalidFileSize: "invalidFileSize", onUploadEmitter: "onUploadEmitter", onUploadStartEmitter: "onUploadStartEmitter", onRemoveFile: "onRemoveFile" }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef((() => UxFileUploadComponent)),
            multi: true,
        }, {
            provide: NG_VALIDATORS,
            useExisting: forwardRef((() => UxFileUploadComponent)),
            multi: true,
        }
    ], viewQueries: [{ propertyName: "inputElement", first: true, predicate: ["Input"], descendants: true }, { propertyName: "fileUploadQueue", first: true, predicate: ["fileUploadQueue"], descendants: true }, { propertyName: "fileUploads", predicate: ["fileUpload"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div class=\"ux-file-upload\">\n    <div class=\"ux-file-upload__button-zone\">\n        <input #Input *ngIf=\"inputType === 'default' || inputType === 'both'\"\n               hidden=\"true\"\n               [accept]=\"allowedFiles\"\n               fileUploadInputFor\n               type=\"file\"\n               (onFileSelected)=\"onChange($event)\"\n               [multiple]=\"isMultiple\"/>\n        <ux-button\n            *ngIf=\"inputType === 'default' || inputType === 'both'\"\n            [isSecondary]=\"true\"\n            (click)=\"inputElement.nativeElement.click()\"\n            iconClass=\"{{ iconClass }}\">\n            {{ chooseFileLabel | translate }}\n        </ux-button>\n    </div>\n    <div *ngIf=\"inputType === 'dragAndDrop' || inputType === 'both'\"\n         fileUploadInputFor\n         (onFileSelected)=\"onChange($event)\"\n         class=\"ux-file-upload__drop-zone\"\n         draggable=\"true\">\n        {{ dragAndDropLabel | translate }}\n    </div>\n    <div>\n        <ux-m-file-upload-queue #fileUploadQueue\n                                [fileAlias]=\"'file'\"\n                                [httpUrl]=\"endpoint\"\n                                multiple>\n            <ux-m-file-upload [file]=\"file\"\n                              #fileUpload\n                              [id]=\"i\"\n                              *ngFor=\"let file of fileUploadQueue.files; let i = index\"\n                              (onUpload)=\"onUpload($event)\"\n                              (onUploadStart)=\"onUploadStart($event)\"\n                              (removeEvent)=\"removeEvent($event)\">\n            </ux-m-file-upload>\n        </ux-m-file-upload-queue>\n    </div>\n</div>\n", styles: [".ux-file-upload__button-zone{margin-bottom:10px}.ux-file-upload__file-name{margin:10px}.ux-file-upload__drop-zone{border:2px dashed grey;color:#ccc;line-height:200px;text-align:center}.ux-file-upload__predefined-section{align-items:center;display:flex}.ux-file-upload .ux-icon:hover{cursor:pointer}.ux-file-upload .mat-card__predefined .mat-progress-bar-primary.mat-progress-bar-fill.mat-progress-bar-element{transform:scaleX(1)!important}\n"], dependencies: [{ kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$1.UxButtonComponent, selector: "ux-button", inputs: ["type", "styleClass", "typeClass", "iconClass", "isOutline", "isSecondary", "isSmall", "isLarge", "isBlock", "isFlat", "isLineWrap", "tabindex", "ariaLabel", "isDisabled", "e2eAttr"] }, { kind: "component", type: UxMFileUploadComponent, selector: "ux-m-file-upload", inputs: ["id", "httpUrl", "httpRequestHeaders", "httpRequestParams", "fileAlias", "file"], outputs: ["removeEvent", "onUpload", "onUploadStart"], exportAs: ["uxMFileUpload"] }, { kind: "component", type: UxMFileUploadQueueComponent, selector: "ux-m-file-upload-queue", inputs: ["httpUrl", "httpRequestHeaders", "httpRequestParams", "fileAlias"], exportAs: ["uxMFileUploadQueue"] }, { kind: "directive", type: FileUploadInputForDirective, selector: "input[fileUploadInputFor], div[fileUploadInputFor]", outputs: ["onFileSelected"] }, { kind: "pipe", type: i2$2.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxFileUploadComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ux-file-upload', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef((() => UxFileUploadComponent)),
                            multi: true,
                        }, {
                            provide: NG_VALIDATORS,
                            useExisting: forwardRef((() => UxFileUploadComponent)),
                            multi: true,
                        }
                    ], encapsulation: ViewEncapsulation.None, template: "<div class=\"ux-file-upload\">\n    <div class=\"ux-file-upload__button-zone\">\n        <input #Input *ngIf=\"inputType === 'default' || inputType === 'both'\"\n               hidden=\"true\"\n               [accept]=\"allowedFiles\"\n               fileUploadInputFor\n               type=\"file\"\n               (onFileSelected)=\"onChange($event)\"\n               [multiple]=\"isMultiple\"/>\n        <ux-button\n            *ngIf=\"inputType === 'default' || inputType === 'both'\"\n            [isSecondary]=\"true\"\n            (click)=\"inputElement.nativeElement.click()\"\n            iconClass=\"{{ iconClass }}\">\n            {{ chooseFileLabel | translate }}\n        </ux-button>\n    </div>\n    <div *ngIf=\"inputType === 'dragAndDrop' || inputType === 'both'\"\n         fileUploadInputFor\n         (onFileSelected)=\"onChange($event)\"\n         class=\"ux-file-upload__drop-zone\"\n         draggable=\"true\">\n        {{ dragAndDropLabel | translate }}\n    </div>\n    <div>\n        <ux-m-file-upload-queue #fileUploadQueue\n                                [fileAlias]=\"'file'\"\n                                [httpUrl]=\"endpoint\"\n                                multiple>\n            <ux-m-file-upload [file]=\"file\"\n                              #fileUpload\n                              [id]=\"i\"\n                              *ngFor=\"let file of fileUploadQueue.files; let i = index\"\n                              (onUpload)=\"onUpload($event)\"\n                              (onUploadStart)=\"onUploadStart($event)\"\n                              (removeEvent)=\"removeEvent($event)\">\n            </ux-m-file-upload>\n        </ux-m-file-upload-queue>\n    </div>\n</div>\n", styles: [".ux-file-upload__button-zone{margin-bottom:10px}.ux-file-upload__file-name{margin:10px}.ux-file-upload__drop-zone{border:2px dashed grey;color:#ccc;line-height:200px;text-align:center}.ux-file-upload__predefined-section{align-items:center;display:flex}.ux-file-upload .ux-icon:hover{cursor:pointer}.ux-file-upload .mat-card__predefined .mat-progress-bar-primary.mat-progress-bar-fill.mat-progress-bar-element{transform:scaleX(1)!important}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.UxAppShellService }, { type: i2$2.TranslateService }]; }, propDecorators: { inputType: [{
                type: Input
            }], endpoint: [{
                type: Input
            }], dragAndDropLabel: [{
                type: Input
            }], bytesOfLabel: [{
                type: Input
            }], bytesLabel: [{
                type: Input
            }], chooseFileLabel: [{
                type: Input
            }], allowedFiles: [{
                type: Input
            }], maxFileSize: [{
                type: Input
            }], isMultiple: [{
                type: Input
            }], iconClass: [{
                type: Input
            }], numberOfFiles: [{
                type: Input
            }], invalidFileSize: [{
                type: Output
            }], onUploadEmitter: [{
                type: Output
            }], onUploadStartEmitter: [{
                type: Output
            }], onRemoveFile: [{
                type: Output
            }], inputElement: [{
                type: ViewChild,
                args: ['Input']
            }], fileUploadQueue: [{
                type: ViewChild,
                args: ['fileUploadQueue']
            }], fileUploads: [{
                type: ViewChildren,
                args: ['fileUpload']
            }] } });
class UxFileUploadComponentModule {
}
/** @nocollapse */ UxFileUploadComponentModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxFileUploadComponentModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ UxFileUploadComponentModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: UxFileUploadComponentModule, declarations: [UxFileUploadComponent], imports: [CommonModule,
        UxButtonComponentModule,
        UxMFileUploadComponentModule,
        UxMFileUploadQueueModule,
        UxFileUploadInputForModule,
        MatProgressBarModule,
        MatIconModule,
        MatCardModule,
        TranslateModule,
        UxTooltipModule], exports: [UxFileUploadComponent] });
/** @nocollapse */ UxFileUploadComponentModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxFileUploadComponentModule, imports: [CommonModule,
        UxButtonComponentModule,
        UxMFileUploadComponentModule,
        UxMFileUploadQueueModule,
        UxFileUploadInputForModule,
        MatProgressBarModule,
        MatIconModule,
        MatCardModule,
        TranslateModule,
        UxTooltipModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxFileUploadComponentModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        UxButtonComponentModule,
                        UxMFileUploadComponentModule,
                        UxMFileUploadQueueModule,
                        UxFileUploadInputForModule,
                        MatProgressBarModule,
                        MatIconModule,
                        MatCardModule,
                        TranslateModule,
                        UxTooltipModule,
                    ],
                    exports: [UxFileUploadComponent],
                    declarations: [UxFileUploadComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { BytesPipe, UxFileUpload, UxFileUploadComponent, UxFileUploadComponentModule, UxMFileUploadComponent, UxMFileUploadComponentModule, UxMFileUploadQueueComponent, UxMFileUploadQueueModule };
